<div class="alert error-alert" @fadeAnimation>
    <span class="alert-icon">&#9888;</span>
    <span class="alert-message" *ngIf="message === ''">Ha ocurrido un error. Por favor, intenta nuevamente.</span>
    <span class="alert-message" *ngIf="message !== ''">{{message}}</span>
    <span class="close-btn" onclick="this.parentElement.style.display='none';" (click)="recargarPagina()">&times;</span>
</div>